import React, { useState } from 'react';
import { Loader, Message } from 'htlib-copy';
import { string, node } from 'prop-types';
import customTypes from 'types';

import Notification from './Notification';

import './AsyncUI.scss';

export default function AsyncUI({ query, loaderHeight, children }) {
  const [showErrorResponse, setShowErrorResponse] = useState(false);

  function onNotificationClose() {
    if (query.reset) {
      query.reset();
    }
  }

  if (query.isLoading) {
    return <Loader height={loaderHeight} />;
  }

  return (
    <>
      {query.error && (
        <Notification type="danger" onClose={onNotificationClose}>
          <p className="AsyncUI__message">{query.error.message}</p>

          {query.error.response && (
            <span
              className="seeDetails small"
              onClick={e => {
                e.stopPropagation();
                setShowErrorResponse(show => !show);
              }}
            >
              {showErrorResponse ? 'hide details' : 'see details'}
            </span>
          )}
          {showErrorResponse && (
            <div className="AsyncUI__errorResponse">
              <Message type="info">
                <pre className="AsyncUI__errorResponsePre">
                  {JSON.stringify(query.error.response.data, null, 2)}
                </pre>
              </Message>
            </div>
          )}
        </Notification>
      )}

      {query.data && query.data.message && (
        <Notification type="success" onClose={onNotificationClose}>
          <p className="AsyncUI__message">{query.data.message}</p>
        </Notification>
      )}

      {children}
    </>
  );
}

AsyncUI.propTypes = {
  query: customTypes.misc.query.isRequired,
  loaderHeight: string,
  children: node,
};

AsyncUI.defaultProps = {
  loaderHeight: '35px',
  children: null,
};
